import React from "react";
import { Container } from "react-bootstrap";
import "./ShipPolicy.css";
import JobSeekerNavbar from "../Pages/Navbar/Navbar";
import EmployerNavbar from "../Pages/Navbar/EmployerNavbar";
import EmployeeNavbar from "../Pages/Navbar/JobSeekerNavbar";
import AgencyNavbar from "../Pages/Navbar/AgencyNavbar";
import AdminNavbar from "../Pages/Navbar/AdminNavbar";
import Footer from "../Footer/Footer"

const user = JSON.parse(localStorage.getItem("user")) || {};

// Determine which Navbar to show
const renderNavbar = () => {
  if (user.user_type === "employer") {
    return <EmployerNavbar />;
  } else if (user.user_type === "job seeker") {
    return <EmployeeNavbar />;
  } else if (user.user_type === "agency") {
    return <AgencyNavbar />;
  } else if (user.user_type === "admin") {
    return <AdminNavbar />;
  } else {
    return <JobSeekerNavbar />;
  }
};

function ShipDeliveryPolicy() {
  return (
    <>
     {renderNavbar()}
      <div className="policy-section py-5 mt-5">
        <Container>
          <h1 className="mb-4 text-center fw-bold">Shipping & Delivery Policy</h1>
          {/* <p className="text-muted text-center">Effective Date: [Insert Date]</p> */}

          <p>
            At <strong>Gulfworker.net</strong>, we strive to provide timely and
            reliable digital delivery of our services. As our platform primarily
            offers job portal and subscription services, the concept of shipping
            applies to activation and accessibility of purchased plans rather
            than physical products.
          </p>

          <div className="mt-4">
            <h4>1. Service Delivery Timeline</h4>
            <ul>
              <li>
                Once a subscription or premium service is purchased, it will be
                activated <strong>instantly</strong> upon successful payment.
              </li>
              <li>
                In rare cases, activation may take up to 24 hours due to
                technical or payment gateway delays.
              </li>
            </ul>

            <h4>2. Confirmation of Service</h4>
            <ul>
              <li>
                Users will receive a confirmation email with details of their
                subscription plan.
              </li>
              <li>
                Employers can immediately access premium features (e.g.,
                highlighted/featured job postings).
              </li>
            </ul>

            <h4>3. Shipping Charges</h4>
            <p>
              Since services are delivered digitally,{" "}
              <strong>no physical shipping charges</strong> are applicable.
            </p>

            <h4>4. International Access</h4>
            <p>
              Gulfworker.net is accessible globally, subject to local laws and
              internet availability. Employers and candidates from different
              countries may use our services without additional charges.
            </p>

            <h4>5. Delays & Technical Issues</h4>
            <ul>
              <li>
                In case of delays in service activation, users should contact our
                support team at{" "}
                <a href="mailto:support@gulfworker.net">support@gulfworker.net</a>.
              </li>
              <li>
                We will ensure prompt resolution and activate the service as soon
                as possible.
              </li>
            </ul>

            <h4>6. Contact Us</h4>
            <p>
              For questions or concerns regarding service delivery, please
              contact our support team at:{" "}
              <a href="mailto:support@gulfworker.net">support@gulfworker.net</a>
            </p>
          </div>
        </Container>
      </div>
      <Footer />
    </>
  );
}

export default ShipDeliveryPolicy;
